import { Component } from '@angular/core';

@Component({
  selector: 'app-distribution-health-info',
  templateUrl: './distribution-health-info.component.html',
  styleUrl: './distribution-health-info.component.scss',
  standalone: false,
})
export class DistributionHealthInfoComponent {}
